import ScrollAnimation from "react-animate-on-scroll";
import styled, { css } from "styled-components";

import { scrollAnimationProps as animationProps } from "globalConstants";
import * as Types from "Types";

import AtomH2 from "Components/Atoms/H2";
import AtomFold from "Components/Atoms/Fold";
import AtomMore from "Components/Atoms/More";
import MoleculeYear from "Components/Molecules/SectionTimeline/Year";
import MoleculeRow from "Components/Molecules/SectionTimeline/Row";

import useTimelineToggle, { actions, statuses } from "reducers/useTimelineToggle";

const Wrap = styled.div<Types.Default>`
   display: flex;
   flex-direction: column;
   align-items: center;
   width: 100%;
   margin-top: 10px;
   & .animated {
      transition-duration: 1s;
      transition-property: opacity;
      transition-timing-function: ease-in-out;
      opacity: 0;
   }
   & .scrollAnimation {
      opacity: 1;
   }
`;

const Year = styled(MoleculeYear)`
   position: relative;
   padding: 70px 0px;
`;
const Row = styled(MoleculeRow)`
   width: 100%;
`;
const RowAnimation = styled(ScrollAnimation)`
   width: 100%;
`;

const LineWrap = styled.div<any>`
   position: relative;
   margin-top: 85px;
   width: 100%;
   padding-bottom: 120px;
   overflow: hidden;
   transition-duration: 1s;
   transition-property: max-height;
   transition-timing-function: ease-in-out;

   ${({ css }) => css}

   &.${statuses.fold} {
      max-height: ${20 * 50 + 110 + 40}px;
   }
   &.${statuses.open} {
      max-height: 9999px;
   }
   &:before {
      content: "";
      position: absolute;
      left: calc(50% - 0.5px);
      top: 0px;
      z-index: 0;
      width: 1px;
      height: 100%;
      background-color: #000;
   }
`;
const LineContents = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   width: 100%;
`;

const ASYAAF = styled.b`
   font-weight: 700;
`;
const GIAF = styled.b`
   font-weight: 900;
   color: #dd4200;
`;

const cssLeft = css`
   padding-right: calc(50% + 35px);
   justify-content: right;
`;
const cssRight = css`
   padding-left: calc(50% + 35px);
   justify-content: left;
`;
const cssDark = css`
   background-color: black;
`;

export default function SectionTimeline(props: Types.Default) {
   const [state, dispatch] = useTimelineToggle();

   function setFold() {
      dispatch({ type: actions.setFold });
   }
   function setOpen() {
      dispatch({ type: actions.setOpen });
   }

   return (
      <Wrap {...props}>
         <ScrollAnimation {...animationProps}>
            <AtomH2>아트맵이 걸어온 길</AtomH2>
         </ScrollAnimation>
         <LineWrap className={state.status}>
            <LineContents>
               <ScrollAnimation {...animationProps}>
                  <Year style={{ paddingTop: "0" }}>2021</Year>
               </ScrollAnimation>

               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={2} style={{ height: "46px" }}></Row.Icon>
                     <Row.Text>글로벌 기업 협업 Google 창구 프로그램 3기 선정</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={3} style={{ height: "14px" }}></Row.Icon>
                     <Row.Text>(주)포커스미디어코리아 디지털 사이니지 아트 콘텐츠 송출 MOU</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={4} style={{ height: "27px" }}></Row.Icon>
                     <Row.Text>코리아스타트업포럼 "THE창업가" 특별전시회 비주얼레이션 및 전시기획</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={5} style={{ height: "37px" }}></Row.Icon>
                     <Row.Text>Boost with Facebook 기업 선정</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={6} style={{ height: "22px" }}></Row.Icon>
                     <Row.Text>Kiaf 서울국제아트페어 스폰서 & 파트너 & 토크라운지 운영</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={7} style={{ height: "22px" }}></Row.Icon>
                     <Row.Text>화랑미술제 미디어 파트너 & 토크라운지 운영</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={8} style={{ height: "25px" }}></Row.Icon>
                     <Row.Text>아트부산 미디어 파트너</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Text>
                        <ASYAAF>ASYAAF</ASYAAF> 아시아프 미디어 파트너
                     </Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={10} style={{ height: "14px" }}></Row.Icon>
                     <Row.Text>어반브레이크 미디어 파트너</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={11} style={{ height: "13px" }}></Row.Icon>
                     <Row.Text>울산아트페어(UiAF) 미디어 파트너</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={12} style={{ height: "15px" }}></Row.Icon>
                     <Row.Text>인천아시아아트쇼 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={13} style={{ height: "41px", margin: "0px -15px" }}></Row.Icon>
                     <Row.Text>한남더힐 하이엔드 ART Exhibition Content Provider</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={14} style={{ height: "20px" }}></Row.Icon>
                     <Row.Text>현대모터스튜디오 부산 전시회 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={15} style={{ height: "26px" }}></Row.Icon>
                     <Row.Text>아모레퍼시픽 설화수 컬처 프로젝트 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={16} css={cssDark} style={{ height: "18px", padding: "2px" }}></Row.Icon>
                     <Row.Text>현대자동차 오픈이노베이션 플랫폼 ZER01NE DAY 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={17} style={{ height: "15px" }}></Row.Icon>
                     <Row.Text>아트경기 x ART369 작가공모/판매 홍보프로모션 </Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={18} style={{ height: "21px" }}></Row.Icon>
                     <Row.Text>예술경영지원센터 지원사업·컨퍼런스 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={19} style={{ height: "17px" }}></Row.Icon>
                     <Row.Text>국립아시아문화전당 ACC 전시회 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={20} style={{ height: "15px" }}></Row.Icon>
                     <Row.Text>대전시립미술관 전시회 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Text>이외 50여개 전시회 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>

               <ScrollAnimation {...animationProps}>
                  <Year>2020</Year>
               </ScrollAnimation>

               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={23} style={{ height: "23px" }}></Row.Icon>
                     <Row.Text>부산경제진흥원 블록체인 특구사업 예술분야 체감형 서비스 파트너</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={24} style={{ height: "47px" }}></Row.Icon>
                     <Row.Text>영국 위치데이터 스타트업 W3W 협력 미술관 정보 맵핑 주소 개발</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={25} style={{ height: "24px" }}></Row.Icon>
                     <Row.Text>아트바이(ART369) 신개념 중저가 작품판매 웹 개발</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={26} style={{ height: "25px" }}></Row.Icon>
                     <Row.Text>아트부산 미디어 파트너</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Text>
                        <ASYAAF>ASYAAF</ASYAAF> 아시아프 홍보 프로모션 제휴
                     </Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={28} style={{ height: "23px" }}></Row.Icon>
                     <Row.Text>달서문화재단 공공미술프로젝트 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={29} style={{ height: "27px" }}></Row.Icon>
                     <Row.Text>성곡미술관 김강용 특별전 작가 인터뷰 영상 제작 및 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={30} style={{ height: "18px" }}></Row.Icon>
                     <Row.Text>무신사테라스 전시회 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={31} style={{ height: "22px" }}></Row.Icon>
                     <Row.Text>현대어린이책미술관 전시회 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={32} style={{ height: "27px" }}></Row.Icon>
                     <Row.Text>페로탕 서울 전시회 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={33} style={{ height: "36px" }}></Row.Icon>
                     <Row.Text>뮤지엄다 전시회 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={34} style={{ height: "20px" }}></Row.Icon>
                     <Row.Text>온라인 작품 판매 플랫폼 DDDD 특별전 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={35} style={{ height: "19px" }}></Row.Icon>
                     <Row.Text>한국만화박물관 특별전 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={36} style={{ height: "23px" }}></Row.Icon>
                     <Row.Text>디 언타이틀드 보이드 전시회 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={37} style={{ height: "18px" }}></Row.Icon>
                     <Row.Text>갤러리CNK 전시회 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Text>이외 20여개 전시회 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>

               <ScrollAnimation {...animationProps}>
                  <Year>2019</Year>
               </ScrollAnimation>

               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={40} style={{ height: "16px" }}></Row.Icon>
                     <Row.Text>아트맵 Android, ios App Beta 서비스 </Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={41} style={{ height: "16px" }}></Row.Icon>
                     <Row.Text>아트맵 웹 서비스 런칭</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={42} style={{ height: "21px" }}></Row.Icon>
                     <Row.Text>한국데이터산업진흥원 웹·앱 콘텐츠 분야 굿콘텐츠 서비스 인증</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={43} style={{ height: "23px" }}></Row.Icon>
                     <Row.Text>서울창업허브 블록체인 서비스 분야 우수기업 선정</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={44} style={{ height: "35px" }}></Row.Icon>
                     <Row.Text>(주)람다256 아트맵 X 루니버스 아트디앱 서비스 파트너</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={45} style={{ height: "17px" }}></Row.Icon>
                     <Row.Text>스페인 바르셀로나 MWC 블록체인 기반 작품 인증 서비스 ARTLOG 출품</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={46} style={{ height: "25px" }}></Row.Icon>
                     <Row.Text>(사)인디053 예술의 성 프로젝트 비주얼브랜딩·마케팅 총괄</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={47} style={{ height: "17px" }}></Row.Icon>
                     <Row.Text>2019 스테어스 아트페어 웹개발 및 미디어 파트너</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={48} style={{ height: "24px" }}></Row.Icon>
                     <Row.Text>(주)망고슬래브 아트라벨·아트캡션 출력 서비스 협약</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Text>
                        <ASYAAF>ASYAAF</ASYAAF> 아시아프 홍보 프로모션 제휴
                     </Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={50} style={{ height: "18px" }}></Row.Icon>
                     <Row.Text>2019 아트제주 미디어 파트너</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={51} style={{ height: "22px" }}></Row.Icon>
                     <Row.Text>현대어린이책미술관 전시회 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={52} style={{ height: "21px" }}></Row.Icon>
                     <Row.Text>대구청년영화제 비주얼브랜딩 총괄</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={53} style={{ height: "24px" }}></Row.Icon>
                     <Row.Text>artbuy.org 신개념 중저가 작품 판매 입찰 플랫폼 사이트 개발(아트플레이스) </Row.Text>
                  </Row>
               </RowAnimation>

               <ScrollAnimation {...animationProps}>
                  <Year>2018</Year>
               </ScrollAnimation>

               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={55} style={{ height: "27px" }}></Row.Icon>
                     <Row.Text>(사)코리아스타트업포럼 회원사</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={56} style={{ height: "32px" }}></Row.Icon>
                     <Row.Text>한국문화예술위원회(ARCO) 문화 미술 서비스분야 서포터즈</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={57} style={{ height: "18px" }}></Row.Icon>
                     <Row.Text>네이버 클라우드 플랫폼 NCP 문화예술 데이터 구축 업무 개발</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={58} style={{ height: "24px" }}></Row.Icon>
                     <Row.Text>ART369 웹 개발·서버 구축 및 미디어 파트너</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Icon rowNumber={59} style={{ height: "19px" }}></Row.Icon>
                     <Row.Text>현대카드 스토리지 전시회 홍보 프로모션</Row.Text>
                  </Row>
               </RowAnimation>

               <ScrollAnimation {...animationProps}>
                  <Year>2017</Year>
               </ScrollAnimation>

               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={61} css={cssDark} style={{ height: "17px", padding: "2px" }}></Row.Icon>
                     <Row.Text>K-Global 빅데이터 스타트업 기술지원 기업 선정</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={62} style={{ height: "32px" }}></Row.Icon>
                     <Row.Text>빅뱅엔젤스 엑셀레이터 프로그램 1기</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={63} style={{ height: "20px" }}></Row.Icon>
                     <Row.Text>중소기업청 주관 스마트벤처캠퍼스 4기</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={64} style={{ height: "14px" }}></Row.Icon>
                     <Row.Text>이스라엘 요즈마그룹 스타트업 엑셀러레이팅 인텐시브 2기</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssRight}>
                     <Row.Text>
                        <GIAF>GIAF</GIAF> 광화문 국제아트페스티벌 홍보 프로모션 제휴
                     </Row.Text>
                  </Row>
               </RowAnimation>

               <ScrollAnimation {...animationProps}>
                  <Year>2016</Year>
               </ScrollAnimation>

               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={67} style={{ height: "23px" }}></Row.Icon>
                     <Row.Text>문화관광부 3.0 문화데이터 활용경진대회 창업개발부문 특별상</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={68} style={{ height: "26px" }}></Row.Icon>
                     <Row.Text>벤처스퀘어 주관 2016 GSC(Global Startup Conference) 참가</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={69} style={{ height: "23px" }}></Row.Icon>
                     <Row.Text>한국문화정보원 주관 문화데이터 활용 사업화기업 지원사 선정</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={70} style={{ height: "20px" }}></Row.Icon>
                     <Row.Text>한국전파통신진흥원 대구 K-ict 스마트미디어센터 입주기업 선정</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <Row css={cssLeft}>
                     <Row.Icon rowNumber={71} style={{ height: "35px" }}></Row.Icon>
                     <Row.Text>대구디지털진흥원 Dip 스마트창작터 - 아트맵 프로토타입 개발</Row.Text>
                  </Row>
               </RowAnimation>
               <RowAnimation {...animationProps}>
                  <RowAnimation {...animationProps}>
                     <Row css={cssRight}>
                        <Row.Icon rowNumber={72} style={{ height: "15px" }}></Row.Icon>
                        <Row.Text>대구 홈 데코 아트페어 아트맵 팝업스토어 진행</Row.Text>
                     </Row>
                  </RowAnimation>
               </RowAnimation>
            </LineContents>
         </LineWrap>
         <RowAnimation style={{ marginTop: "80px" }} {...animationProps}>
            {state.status === statuses.fold && <AtomMore onClick={setOpen}></AtomMore>}
            {state.status === statuses.open && <AtomFold onClick={setFold}></AtomFold>}
         </RowAnimation>
      </Wrap>
   );
}
